import React, { useState, useEffect } from "react";
import logo from "../assets/Group 2.svg";
import { useNavigate } from 'react-router-dom';

const Navbar = ({
    onHomeClick,
    onIngredientsClick,
    onRecipesClick,
    onPumpsClick,
    onReportsClick,
    onConfigurationsClick
}) => {
    const [activeAnchor, setActiveAnchor] = useState("");
    const [ulog, setUlog] = useState(false);
    const [uName, setUName] = useState("");
    const [uId , setUId] = useState("");
    const [uImg, setUImg] = useState("");
    const [uMmbr, setUMmbr] = useState("");
  const [userD, setUserD] = useState(null);

    const handleAnchorClick = (anchor) => {
        setActiveAnchor(anchor);
    };
    useEffect(() => {
        const userDataString = sessionStorage.getItem('userData');
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserD(userData);
            // Use userData as needed
        }
    }, []);
    useEffect(() => {
        setUId(userD?.id); 
        setUName(userD?.name); 
        const userDate = userD ?.datetime;
        const spltD = userDate ?.split("T")[0];
        setUMmbr(spltD);
        const defImg = require(`../components/img/images/user.png`);
        if (userD?.u_img) {
            try {
              // Try to import the image dynamically
              const image = require(`../..//img/userimages/${userD.u_img}`);
              
              setUImg(image);
            } catch (error) {
              // If image is not found, use default image
              console.error("Image not found:", error);
              setUImg(defImg);
            }
          } else {
            setUImg(defImg);
          }
    }, [userD]);
    const navigate = useNavigate();
const togglelog = function(){
    setUlog(!ulog);
}
const signOutFunc = () => {
    sessionStorage.removeItem('userData');
    navigate('/'); 
};
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light full-navbar">
            <div className="container">
                <img src={logo} alt='logo' className="divLogo2"/>
            {/* <div className="btnsSm"> */}
            <div className="userDetails-s" onClick={togglelog}>
                        <div className="shadeTriangle-u-s"></div>
                    <div className="u-pic-s">
                        <img src={uImg} alt='user' className='sp-icon coverObj' />
                    </div>
                    <div className="u-name-s">
                        {uName}
                    </div>
                </div>
            <div className='logout-s' style={{display: ulog ? 'block' : 'none'}}>
                <div className='rel-po'>
                <div className='shadeTriangle-rel-po'></div>
                <div className="ulo-pic">
                        <div className='ul-pic'>
                        <img src={uImg} alt='user' className='sp-icon ul-iimg' />
                        </div>
                    </div>
                <div className='admin-name'>
                    {uName} - Admin
                    <div className='mbr-shp'>
                        Member since {uMmbr}
                    </div>
                </div>
                <div className='oL-btn'>
                <div className='shadeTriangle-ot-btn'></div>
                    <button className='out-btn' onClick={signOutFunc}>
                        Sign Out
                    </button>
                </div>
                
                </div>
                </div>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse bg-color" id="navbarNav" >
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <a className="nav-link" href="#" onClick={onHomeClick}>Home</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/ingredients" onClick={onIngredientsClick}>Ingredients</a>
                        </li>
                        <li className="nav-item" >
                            <a className="nav-link" href="#" onClick={onRecipesClick} >Recipes</a>
                        </li>
                        <li className="nav-item" >
                            <a className="nav-link" href="#" onClick={onPumpsClick} >Pumps</a>
                        </li>
                        <li className="nav-item" >
                            <a className="nav-link" href="#" onClick={onReportsClick}>Report</a>
                        </li>
                        <li className="nav-item" >
                            <a className="nav-link" href="#" onClick={onConfigurationsClick}>Configuration</a>
                        </li>
                    </ul>
                </div>
            </div> 
            {/* </div> */}
        </nav>
    );
};

export default Navbar;
